import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'
import SubmitButton from 'component/button/Submit'
import InvalidText from 'component/invalid/text'
import { FormSwitch } from 'component/forms'
import { getMediaDuration } from 'util/global'
import {
  FormInputName,
  FormInputUrutan,
  FormSelectSection,
  FormSelectPrecontent,
  FormInputTanggal,
  FormActiveStatus,
  FormActiveKey,
  FormSelectFeedback,
  FormGroupKecil,
  FormInputDesc,
  FormInputEndedAt,
  PreviewAudioLink,
  InfoGdrive,
  InfoAudio,
  FormTextArea,
  FormSetToBeScore,
  FormSelectStudent,
} from 'component/content-form'

export default function AddContentAudio() {
  /* ========================================== Helpers ========================================= */
  const history = useHistory()
  const location = useLocation()
  const params = useParams()
  
  /* ====================================== Consume Context ===================================== */
  const { getRequest, postRequest } = useBaseContext()

  /* ========================================= Constants ======================================== */
  const links = [
    { url: '/kelas', name: 'Sub Mata Pelajaran' },
    { url: `/kelas/${location.state.kelasId}`, name: 'Overview' },
  ]
  const sections = location.state.sectionList ? location.state.sectionList : []

  /* ======================================= Local States ======================================= */
  const [selectAudio, setSelectAudio]           = useState({ link: true, internal: false })
  const [existingContents, setExistingContents] = useState([])
  const [namaKonten, setNamaKonten]             = useState('')
  const [urutan, setUrutan]                     = useState('')
  const [sectionId, setSectionId]               = useState('')
  const [preContentId, setPrecontentId]         = useState('')
  const [active, setActive]                     = useState(0)
  const [displayAt, setDisplayAt]               = useState('')
  const [feeds, setFeeds]                       = useState([])
  const [feedId, setFeedId]                     = useState(null)
  const [isFeedActive, setIsFeedActive]         = useState(0)
  const [enableGroup, setEnableGroup]           = useState(false)
  const [maxGroup, setMaxGroup]                 = useState('')
  const [descGroup, setDescGroup]               = useState('')
  const [endedAt, setEndedAt]                   = useState('')
  const [description, setDescription]           = useState('')
  const [apresiasi, setApresiasi]               = useState('')
  const [rating, setRating]                     = useState(1)
  const [enableGroupKey, setEnableGroupKey]     = useState(false)
  const [prerequisite, setPrerequisite]         = useState('')
  
  //================ FILE STATE ==================
  const [contentUrl, setContentUrl]                     = useState('')
  const [linkContent, setLinkContent]                   = useState('')
  const [currentAudioFilename, setCurrentAudioFilename] = useState('')
  const [file, setFile]                                 = useState(null)
  const [duration, setDuration]                         = useState(0)

  //================ VALID STATE =================
  const [isNamaInvalid, setIsNamaInvalid]         = useState(false)
  const [isUrutanInvalid, setIsUrutanInvalid]     = useState(false)
  const [isSectionInvalid, setIsSectionInvalid]   = useState(false)
  const [isAudioInvalid, setIsAudioInvalid]       = useState(false)
  const [isFileTypeInvalid, setIsFileTypeInvalid] = useState(false)
  const [isMaxGroupValid, setIsMaxGroupValid]     = useState(true)
  const [isUploading, setIsUploading]             = useState(false)
  const [toBeScore, setToBeScore]   = useState({
    isScore: false,
    isKeterampilan: false,
    isPengetahuan: false,
    selectedTypeScore: '',
    isTypeScoreActive: true,
  })
  const [selectedStudents, setSelectedStudents] = useState([])

  /* =========================================== Refs =========================================== */
  const refInputName     = useRef()
  const refSelectSection = useRef()
  const refInputUrutan   = useRef()
  const refMaxGroup      = useRef()

  /* ========================================= Functions ======================================== */
  function getExistingContentsBySelectedSection() {
    if (!sectionId) {
      setExistingContents([])
    } else {
      sections.forEach((section) => {
        if (section.id === sectionId) {
          setExistingContents(section.contents)
        }
      })
    }
  }

  async function getFeedsList() {
    const response = await getRequest('feed')
    if (response) {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.description,
      }))
      setFeeds(options)
    } else {
      console.error('ERROR', response)
    }
  }

  function handleChangeName(event) {
    setNamaKonten(event.target.value)
  }

  function handleChangeUrutan(event) {
    setUrutan(event.target.value)
  }

  function handleChangeSection(event) {
    setSectionId(event.target.value)
  }

  function handleChangePrecontent(event) {
    setPrecontentId(event.target.value)
  }

  function handleChangeActive() {
    if (active === 1) {
      setActive(0)
    }
    if (active === 0) {
      setActive(1)
    }
  }

  function handleChangeEnableGroupKey() {
    if (enableGroupKey) {
      setEnableGroupKey(false)
    } else {
      setEnableGroupKey(true)
    }
  }

  function handleChangeDate(event) {
    setDisplayAt(event.target.value)
  }

  function handleChangeDesc(event) {
    setDescription(event.target.value)
  }

  function handleChangeEndedAt(event) {
    setEndedAt(event.target.value)
  }

  function handleUseLink() {
    setSelectAudio({
      link: true,
      internal: false,
    })
  }

  function handleUseInternalFile() {
    setSelectAudio({
      link: false,
      internal: true,
    })
  }

  function handleAudioContent(content) {
    if (typeof content === 'string') {
      setLinkContent(content)

      if (content.includes('drive.google.com')) {
        setContentUrl({ name: null, data: content, source: 'gdrive' })
      } else if (content.includes('soundcloud.com')) {
        setContentUrl({ name: null, data: content, source: 'soundcloud' })
      } else {
        setContentUrl({ name: null, data: content, source: 'umum' })
      }
    } else if (`${typeof content}` === 'object') {
      const check = handleValidateMp3(content.name)
      if (check === 'sesuai') {
        setFile(content)
        setCurrentAudioFilename(content.name)
        setContentUrl({
          name: content.name,
          data: 'internal',
          source: 'internal',
        })
      }
    } else {
      setContentUrl(null)
      setFile(null)
      setCurrentAudioFilename('')
    }
  }

  function handleValidateMp3(fileName) {
    const fileExtension = fileName.split('.').pop()
    const mp3Extension = 'mp3'
    if (fileExtension !== mp3Extension) {
      setIsFileTypeInvalid(true)
      return 'tidak sesuai'
    } else {
      setIsFileTypeInvalid(false)
      return 'sesuai'
    }
  }

  function handleChangeFeedback(val) {
    setFeedId(val)
  }

  function handleChangeEnableGroup() {
    if (enableGroup) {
      setEnableGroup(false)
      setMaxGroup('')
      setIsMaxGroupValid(true)
    } else {
      setEnableGroup(true)
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeMaxGroup(event) {
    if (event.target.value) {
      const absolute = Math.abs(event.target.value)
      const integer = Math.round(absolute)
      setMaxGroup(integer)
      if (integer <= 0) {
        setIsMaxGroupValid(false)
      } else {
        setIsMaxGroupValid(true)
      }
    } else {
      setMaxGroup('')
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeDescGroup(event) {
    setDescGroup(event.target.value)
  }

  function handleChangeApresiasi(event) {
    setApresiasi(event.target.value)
  }

  function handleChangeRating(value) {
    setRating(value ? 1 : 0)
  }

  function toBeScoreValidation() {
    if (toBeScore.isScore) {
      return (toBeScore.isKeterampilan === true || toBeScore.isPengetahuan === true) && toBeScore.selectedTypeScore
    }

    return true
  }

  function handleValidation() {
    const newUrutan = urutan ? Math.abs(parseInt(urutan)) : 0
    const feedback = isFeedActive === 1 ? feedId : ''

    if (namaKonten && urutan && sectionId && contentUrl && isMaxGroupValid && toBeScoreValidation()) {
      setIsNamaInvalid(false)
      setIsSectionInvalid(false)
      setIsUrutanInvalid(false)
      setIsAudioInvalid(false)
      handleSubmitForm(
        contentUrl,
        namaKonten,
        sectionId,
        newUrutan,
        active,
        displayAt,
        preContentId,
        feedback.value,
        maxGroup,
        descGroup,
        endedAt,
        description,
        apresiasi,
        rating,
      )
    } else {
      if (!isMaxGroupValid) {
        if (refMaxGroup) {
          refMaxGroup.current.focus()
        }
      }

      if (!sectionId) {
        setIsSectionInvalid(true)
        refSelectSection.current.focus()
      } else {
        setIsSectionInvalid(false)
      }

      if (!urutan) {
        setIsUrutanInvalid(true)
        refInputUrutan.current.focus()
      } else {
        setIsUrutanInvalid(false)
      }

      if (!contentUrl) {
        setIsAudioInvalid(true)
      } else {
        setIsAudioInvalid(false)
      }

      if (!namaKonten) {
        setIsNamaInvalid(true)
        refInputName.current.focus()
      } else {
        setIsNamaInvalid(false)
      }
      window.notification('Mohon', 'lengkapi data')

      if (!toBeScoreValidation()) {
        window.notification('Mohon', 'lengkapi juga data "Jadikan Sebagai Penilaian"')
      }
    }
  }

  async function handleSubmitForm(
    contentUrl,
    namaKonten,
    sectionId,
    urutan,
    active,
    displayAt,
    preContentId,
    feedId,
    maxGroup,
    descGroup,
    endedAt,
    description,
    apresiasi,
    rating,
  ) {
    let form = new FormData()
    form.append('duration', duration)
    form.append('content_type', 2)
    form.append('contents_url', JSON.stringify(contentUrl))
    form.append('title', namaKonten)
    form.append('section_id', sectionId)
    form.append('urutan', urutan)
    form.append('active', active)
    form.append('rating', rating)

    form.append('is_score', !!toBeScore.isScore)

    if (toBeScore.isScore) {
      form.append('is_keterampilan', !!toBeScore.isKeterampilan)
      form.append('is_pengetahuan', !!toBeScore.isPengetahuan)
      form.append('type_score_id', toBeScore.selectedTypeScore)
    }

    if (Array.isArray(selectedStudents) && !!selectedStudents.length) {
      selectedStudents.forEach((selectedStudent, selectedStudentIndex) => {
        form.append(`spesifik_user_id[${selectedStudentIndex}]`, selectedStudent.id)
      })
    }

    if (displayAt) {
      form.append('display_at', displayAt)
    }

    if (endedAt) {
      form.append('ended_at', endedAt)
    }

    if (description) {
      form.append('deskripsi', description)
    }

    if (preContentId) {
      form.append('precontent_id', preContentId)
    }

    if (feedId) {
      form.append('feedback', feedId)
    }

    if (enableGroup) {
      form.append('group_status', 1)
      if (maxGroup) {
        form.append('group_max', maxGroup)
      }
      if (descGroup) {
        form.append('group_description', descGroup)
      }
    }

    if (apresiasi) {
      form.append('apresiasi', apresiasi)
    }

    if (contentUrl.source === 'internal') {
      const { id } = JSON.parse(localStorage.getItem('user'))
      const profile_id = JSON.parse(localStorage.getItem('profile')).id
      form.append('path', `upload/${profile_id}/classes/contents`)
      form.append('temp_name', `file-temp-${id}-${Date.now()}.mp3`)
      form.append('file_upload', file)
    }

    setIsUploading(true)
    const response = await postRequest('contents', form)
    setIsUploading(false)
    if (response) {
      if (enableGroupKey) {
        let formkey = new FormData()
        formkey.append('description', prerequisite)
        formkey.append('content_id', response.data.id)

        const response1 = await postRequest('contentTakeAway', formkey)
        if (response1) {
          window.notification('Materi', 'berhasil ditambahkan', 'success')
          history.push(`/kelas/${location.state.kelasId}`)
        }
      } else {
        window.notification('Materi', 'berhasil ditambahkan', 'success')
        history.push(`/kelas/${location.state.kelasId}`)
      }
    } else {
      console.error('ERROR', response)
      window.notification(
        'Terjadi kesalahan',
        'Coba beberapa saat lagi',
        'error',
      )
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getFeedsList()
  }, [])

  useEffect(() => {
    getExistingContentsBySelectedSection()
  }, [sectionId])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header
          pageName="Tambah Materi Audio"
          linkName="Materi Audio"
          links={links}
        />
        
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                <h5>
                  <i className="fas fa-volume-up mr-1" />
                  Informasi Audio
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <form>
                      {/* Input Nama Konten */}
                      <FormInputName
                        label="Nama Audio"
                        placeholder="Nama Audio"
                        namaKonten={namaKonten}
                        handleChangeName={handleChangeName}
                        isNamaInvalid={isNamaInvalid}
                        refInputName={refInputName}
                      />

                      {/* Input Audio */}
                      <fieldset className="form-group row mb-5">
                        <label className="col-sm-3 col-form-label">
                          <span className="mr-1">Audio</span>
                        </label>
                        <div className="col-sm-9 row mb-3">
                          <div className="col">
                            <div className="form-check">
                              <input
                                onChange={() => handleUseLink()}
                                className="form-check-input"
                                type="radio"
                                name="selectAudio"
                                id="soundcloud"
                                defaultValue={1}
                                defaultChecked={true}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="soundcloud"
                              >
                                <i className="feather icon-link mr-1" />
                                <span>Link</span>
                                <span className="ml-1">
                                  (Google Drive, Soundcloud, atau link umum)
                                </span>
                              </label>
                            </div>
                            {selectAudio.link ? (
                              <div className="mb-4">
                                <InfoGdrive />
                                <input
                                  type="text"
                                  value={linkContent}
                                  onChange={(event) =>
                                    handleAudioContent(event.target.value)
                                  }
                                  className="form-control my-3"
                                  placeholder="Link: : https://drive.google.com/file/d/xyz atau https://soundcloud.com/user/xyz  atau link umum"
                                />
                                {linkContent ? (
                                  <PreviewAudioLink link={linkContent} />
                                ) : null}
                              </div>
                            ) : null}
                            <div className="form-check">
                              <input
                                onChange={() => handleUseInternalFile()}
                                className="form-check-input"
                                type="radio"
                                name="selectAudio"
                                id="uploadAudio"
                                defaultValue={0}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="uploadAudio"
                              >
                                <i className="fas fa-file-audio mr-1" />
                                <span>Upload file audio (mp3)</span>
                              </label>
                            </div>
                            {selectAudio.internal ? (
                              <div className="custom-file">
                                <input
                                  type="file"
                                  accept="audio/*"
                                  onChange={async (event) => {
                                    handleAudioContent(event.target.files[0])
                                    let getDur = await getMediaDuration(
                                      event.target.files[0],
                                    )
                                    let durSec = Math.round(getDur)
                                    setDuration(durSec)
                                  }}
                                  className="custom-file-input"
                                  id="input-upload-audio"
                                  style={{ position: 'absolute' }}
                                />
                                <label
                                  className="custom-file-label"
                                  htmlFor="input-upload-audio"
                                  style={{
                                    position: 'relative',
                                    width: '100%',
                                  }}
                                >
                                  {currentAudioFilename
                                    ? currentAudioFilename
                                    : 'Pilih file audio'}
                                </label>
                                {isFileTypeInvalid ? (
                                  <div>
                                    <label className="col small form-text text-danger">
                                      Type file audio harus mp3.
                                    </label>
                                    <InfoAudio />
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                            {isAudioInvalid ? (
                              <InvalidText name={'Audio'} />
                            ) : null}
                          </div>
                        </div>
                      </fieldset>

                      {/* Input Urutan */}
                      <FormInputUrutan
                        urutan={urutan}
                        handleChangeUrutan={handleChangeUrutan}
                        isUrutanInvalid={isUrutanInvalid}
                        refInputUrutan={refInputUrutan}
                      />

                      {/* Input deskripsi */}
                      <FormInputDesc
                        description={description}
                        handleChangeDesc={handleChangeDesc}
                      />

                      {/* Input Apresiasi */}
                      <FormTextArea
                        id="formInputApresiasi"
                        label="Apresiasi"
                        placeholder="Apresiasi/pesan setelah siswa menyelesaikan materi (opsional)"
                        className="mb-5"
                        value={apresiasi}
                        handleChange={handleChangeApresiasi}
                      />

                      {/* Select Section */}
                      <FormSelectSection
                        sections={sections}
                        handleChangeSection={handleChangeSection}
                        isSectionInvalid={isSectionInvalid}
                        refSelectSection={refSelectSection}
                      />

                      {/* Select Precontent */}
                      <FormSelectPrecontent
                        existingContents={existingContents}
                        handleChangePrecontent={handleChangePrecontent}
                      />

                      {/* Input Tanggal Ditampilkan */}
                      <FormInputTanggal
                        existingDisplayAt={displayAt}
                        handleChangeDate={handleChangeDate}
                      />

                      {/* Input ended at */}
                      <FormInputEndedAt
                        endedAt={endedAt}
                        handleChangeEndedAt={handleChangeEndedAt}
                      />

                      {/* Rating */}
                      <FormSwitch
                        id="formRating"
                        label="Rating Materi"
                        value={rating}
                        handleChange={handleChangeRating}
                      />

                      {/* Select Feedback */}
                      <FormSelectFeedback
                        existingFeedId={feedId}
                        existingFeeds={feeds}
                        isFeedActive={isFeedActive}
                        setIsFeedActive={setIsFeedActive}
                        handleChangeFeeds={handleChangeFeedback}
                        getFeedList={getFeedsList}
                      />

                      {/* Swicth Group Kecil */}
                      <FormGroupKecil
                        enableGroup={enableGroup}
                        handleChangeEnableGroup={handleChangeEnableGroup}
                        maxGroup={maxGroup}
                        descGroup={descGroup}
                        handleChangeMaxGroup={handleChangeMaxGroup}
                        handleChangeDescGroup={handleChangeDescGroup}
                        isMaxGroupValid={isMaxGroupValid}
                        refMaxGroup={refMaxGroup}
                      />

                      {/* Select Specific Students */}
                      <FormSelectStudent 
                        selectedStudents={selectedStudents}
                        setSelectedStudents={setSelectedStudents}
                        subMapelId={params?.kelasId}
                        isWithCheckSavedOrNot={false}
                      />

                      {/* Select To Be Score Or Not */}
                      <FormSetToBeScore
                        value={toBeScore}
                        handleChange={setToBeScore}
                      />

                      {/* Select Status */}
                      <FormActiveStatus
                        existingStatus={active}
                        handleChangeStatus={handleChangeActive}
                      />

                      <FormActiveKey
                        enableGroupKey={enableGroupKey}
                        handleChangeEnableGroupKey={handleChangeEnableGroupKey}
                        prerequisite={prerequisite}
                        setPrerequisite={setPrerequisite}
                      />

                      <div className="form-group">
                        <button
                          onClick={() =>
                            history.push(`/kelas/${location.state.kelasId}`)
                          }
                          type="button"
                          className="btn btn-outline-danger has-ripple mr-2"
                        >
                          Kembali
                        </button>
                        {isUploading ? (
                          <button
                            disabled={true}
                            type="button"
                            className="btn btn-success mr-2"
                          >
                            <span
                              className="spinner-border spinner-border-sm mr-1"
                              role="status"
                            />
                            <span>Simpan</span>
                          </button>
                        ) : (
                          <SubmitButton
                            onClick={() => handleValidation()}
                            text="Simpan"
                          />
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
